
export default class History {
  cmdPos = -1;
  cmdMaxPos = this.cmdPos;
  callback: Function;
  localKey: string = 'baseProjectData'; // 存储的可以
  constructor(callback, type?: string) {
    this.callback = callback
    if (type === 'cut') {
      this.localKey = 'cutProjectData'
    }
  }
  /**
   * 保存数据
   * @param projectData
   * @returns 
   */
  saveBaseProjectDataToStorage(projectData) {
    const dataList = this.getAllProjectDataFromStorage();
    const lastDataInfo = dataList[dataList.length - 1] || {}
    if (!projectData) return;
    if (JSON.stringify(lastDataInfo) === JSON.stringify(projectData)) return
    this.cmdPos = this.cmdPos + 1;
    dataList.splice(this.cmdPos, 0, projectData);
    this.cmdMaxPos = this.cmdPos;
    this.callback && this.callback();
    localStorage.setItem(this.localKey, JSON.stringify(dataList));
  }
  /**
   * 获取全部数据
   * @returns
   */
  getAllProjectDataFromStorage() {
    const baseProjectDataStr = localStorage.getItem(this.localKey);
    if (baseProjectDataStr) {
      return JSON.parse(baseProjectDataStr);
    }
    return [];
  }
  /**
   * 清空全部数据
   */
  removeAllProjectDataFromStorage() {
    localStorage.removeItem(this.localKey);
  }
  /**
   * 根据索引获取存储
   * @param pos 
   * @returns 
   */
  getProjectDataFromStorage(pos) {
    const baseProjectDataStr = localStorage.getItem(this.localKey);
    if (baseProjectDataStr) {
      return JSON.parse(baseProjectDataStr)[pos];
    }
    return [];
  }
  /**
   * 返回当前项目数据
   * @returns
   */
  getCurrentProjectDataFromStorage() {
    return this.getProjectDataFromStorage(this.cmdPos);
  }
  /**
   * 撤销
   * @returns
   */
  undoProjectDataFromStorage() {
    if (this.canUndo()) {
      console.log('undoProjectDataFromStorage---前',  this.cmdPos);
      this.cmdPos--;
      console.log('undoProjectDataFromStorage---后',  this.cmdPos);
      return this.getProjectDataFromStorage(this.cmdPos);
    }
    return {};
  }
  /**
   * 回退
   * @returns
   */
  redoProjectDataFromStorage() {
    if (this.canRedo()) {
      this.cmdPos++
      return this.getProjectDataFromStorage(this.cmdPos);
    }
    return {};
  }
  /**
   * 判断是否能撤销
   * @returns
   */
  canUndo() {
    return this.cmdPos > 0;
  }
  canRedo () {
    return this.cmdPos <= this.cmdMaxPos - 1;
  }
}